import { render, staticRenderFns } from "./DriverCard.vue?vue&type=template&id=49e87044&"
import script from "./DriverCard.vue?vue&type=script&lang=js&"
export * from "./DriverCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports